/* globals jQuery */
//https://swiperjs.com/
import Swiper from 'swiper/bundle'; // import Swiper bundle with all modules installed

(($) => {

    //TESTIMONIAL SLIDESHOW
	var testimonialSwiper = new Swiper('.slideshow-testimonial', {
		loop: true,
        autoplay:{
            delay: 7000, //7 seconds per slide
            disableOnInteraction: false
		},
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			hideOnclick: false,
			clickable: true
		}
    });
    

    // INTERIOR GALLERY w/ Caption
	// gallery swiper
	var galleryTop = new Swiper('.gallery-slideshow', {
		loop: true,
		fadeEffect: { crossFade: true },
		effect: 'fade',
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		}
	});
    // gallery caption
	var galleryCaption = new Swiper('.gallery-slideshow-caption', {
		loop: true,
		fadeEffect: { crossFade: true },
		effect: 'fade',
		pagination: {
			el: '.swiper-pagination',
			type: 'bullets',
			hideOnclick: false,
			clickable: true
		},
		controller: { control: galleryTop },
	});
	// control caption with top after caption has been initialized
	if ( document.querySelector('.gallery-slideshow') ) {
		galleryTop.controller.control = galleryCaption;
	}

	var productSwiper = new Swiper('.product-slideshow', {
		slidesPerView: 1,
		spaceBetween: 20,
		speed: 1000,
		loop: true,
		slidesPerGroup: 1,
		observer: true,
		observeParents: true,
		keyboard: {
			enabled: true
		},
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
		a11y: {
			enabled: true,
			prevSlideMessage: 'Previous slide',
			nextSlideMessage: 'Next slide',
		},
		breakpoints: {
			530: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 30,
			},
			768: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 30,
			},
			1000: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 30,
			},
			// when window width is >= 1200px
			1200: {
				slidesPerView: 4,
				slidesPerGroup: 4,
				spaceBetween: 30,
			}
		}
	});

})(jQuery)